import type { EventCategory } from '../api/types'

/** Event categories (api/events/categories.py EventCategory), in picker order. */
export const EVENT_CATEGORIES: readonly { value: EventCategory; label: string }[] = [
  { value: 'alarm', label: 'Alarm' },
  { value: 'door', label: 'Door' },
  { value: 'access', label: 'Access' },
  { value: 'intercom', label: 'Intercom' },
  { value: 'system', label: 'System' },
  { value: 'admin', label: 'Admin' },
]

/** Category values -> labels in canonical order (the API returns them
 *  alphabetically); unknown values are kept verbatim at the end. */
export function categoryLabels(values: readonly string[]): string[] {
  const known = EVENT_CATEGORIES.filter((c) => values.includes(c.value)).map((c) => c.label)
  const unknown = values.filter((v) => !EVENT_CATEGORIES.some((c) => c.value === v))
  return [...known, ...unknown]
}

/** Canonical-order copy of `values` (stable payloads for PUTs). */
export function sortCategories(values: readonly string[]): string[] {
  return EVENT_CATEGORIES.map((c) => c.value).filter((v) => values.includes(v))
}
